import { FC } from "react";
import { CompanyOverview as TCompanyOverview } from "@vviinn/user-managment-client-ts";

import { useAppSelector } from "../store";

import { Restricted } from "../components/Restricted";
import StatsUnited from "./stats/StatsUnited";
import { Stat } from "./stats/types";
import { SubSectionWithStyles } from "../ui/layout";

const createOverviewStats = (
  data: Pick<TCompanyOverview, "totalApiRequests">,
): Stat[] => {
  return [
    {
      name: "API Requests",
      primaryStat: data.totalApiRequests,
    },
  ];
};

export const NO_DATA_MESSAGE = "No data available";

export const CompanyOverview: FC<React.PropsWithChildren> = () => {
  const overview = useAppSelector((state) => state.dashboard.overview);
  const stats = createOverviewStats(overview);

  return (
    <SubSectionWithStyles
      title="Company Overview"
      isSubHeader={false}
      withGroup={false}
    >
      {overview.totalApiRequests ? (
        <Restricted permissions="dashboard:overview:view">
          <StatsUnited stats={stats} />
        </Restricted>
      ) : (
        <p className="text-primary">{NO_DATA_MESSAGE}</p>
      )}
    </SubSectionWithStyles>
  );
};
